import getDayName from "./getDayName";
import getMonthName from "./getMonthName";

const dateTimeFormat = (
  inputDate: Date | string,
  format = "[y]-[m]-[d] [h]:[i]:[s]",
  utc = false,
): string => {
  const dateOb = getDateObject(inputDate, utc);

  return format
    .replaceAll("[y]", dateOb.getFullYear() + "")
    .replaceAll("[m]", addPreZero(dateOb.getMonth() + 1))
    .replaceAll("[d]", addPreZero(dateOb.getDate()))
    .replaceAll("[h]", addPreZero(dateOb.getHours()))
    .replaceAll("[i]", addPreZero(dateOb.getMinutes()))
    .replaceAll("[s]", addPreZero(dateOb.getSeconds()))
    .replaceAll("[mn]", getMonthName(dateOb.getMonth()))
    .replaceAll("[dn]", getDayName(dateOb.getDay()));
};

const addPreZero = (v: number): string => {
  return v < 10 ? "0" + v : "" + v;
};

export default dateTimeFormat;

const getDateObject = (input: Date | string, utc: boolean) => {
  if(typeof input == 'string') {
    let s = input.replaceAll('-', '/');
    if(utc) {
      s += ' UTC';
    }
    return new Date(s);
  }
  return input;
}